import React, { useEffect, useState } from "react";
import Qcast from "./pages/qcast-logo";
import "./styles/app.css";

const App = () => {
  const [themeColor, setThemeColor] = useState("#005EB8");
  const [fontColor, setFontColor] = useState("#FFFFFF");

  const location = window.location;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const themeParam = urlParams.get("themeColor");
    const fontParam = urlParams.get("fontColor");
    setThemeColor("#" + themeParam);
    setFontColor("#" + fontParam);
  }, [location]);

  function inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
  return (
    <div className="main-plugin">
      {inIframe() ? (
        <Qcast backgroundColor={themeColor} fontColor={fontColor} />
      ) : (
        <div></div>
      )}
    </div>
  );

  // return (
  //   <div className="main-plugin">
  //     <Qcast
  //       backgroundColor="var(--theme-bg)"
  //       fontColor="var(--theme-fontColor)"
  //     />
  //   </div>
  // );
};

export default App;
